import { useI18n } from 'next-localization';
import { useFetchPremiumLineChartDataQuery } from '@/store/fundDetails/services/fundDetailsApi';
import usePayload from 'hooks/useFundDetailsRequestPayload';
import useHelpers from 'hooks/helpers';
import AlertMessageBase from 'components/Generic/AlertMessageBase';
import FundDetailsPremiumDiscountLineChart from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountLineChart';
import FundDetailsPremiumDiscountLineChartTable from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPremiumDiscountTab/FundDetailsPremiumDiscountLineChartTable';
import BaseSkeleton from 'components/Generic/BaseSkeleton';

const FundDetailsPremiumDiscountLineChartSection = ({ className }: string) => {
  const { t } = useI18n();
  const { getErrorDictionary } = useHelpers();
  const { language, shareClass } = usePayload();
  const { data, error, isFetching } = useFetchPremiumLineChartDataQuery({ language, shareClass });

  return (
    <div className={className}>
      <h3>{t('fundDetailsPremiumDiscountGraphDataTitle')}</h3>

      {error ? (
        <AlertMessageBase type="error" title={t(getErrorDictionary(error))} className="mt-4" />
      ) : isFetching ? (
        <div className="loading-overlay">
          <BaseSkeleton height="100%" />
        </div>
      ) : (
        <>
          <div className="mt-4">
            <h4>{t('fundDetailsPremiumDiscountLineGraphTitle')}</h4>
            <FundDetailsPremiumDiscountLineChart data={data?.points} className="mt-4" />
          </div>

          <div className="mt-6">
            <h4>{t('fundDetailsPremiumDiscountDataTableTitle')}</h4>
            <FundDetailsPremiumDiscountLineChartTable
              data={data?.periods}
              className="mt-4"
              isFetching={isFetching}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default FundDetailsPremiumDiscountLineChartSection;
